module.exports = __webpack_public_path__ + "img/logo.65fce5aa.svg";